export default __webpack_public_path__ + "static/media/un_select_icon.c89e1ea4.svg";